import { render, staticRenderFns } from "./SitchOrderItemBreakdown.vue?vue&type=template&id=60f48e6c&scoped=true&"
import script from "./SitchOrderItemBreakdown.vue?vue&type=script&lang=ts&"
export * from "./SitchOrderItemBreakdown.vue?vue&type=script&lang=ts&"
import style0 from "./SitchOrderItemBreakdown.vue?vue&type=style&index=0&id=60f48e6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f48e6c",
  null
  
)

export default component.exports